<div class="lens-module-prod-data lens-steps">
  <div class="prod-image">
    <img [attr.src]="productData?.imageUrl" alt="" onerror="this.style.display='none'"/>
  </div>
  <div class="product-data-box">
    <h1>{{productData?.brand}} {{productData?.description}}</h1>
    <p>{{productData?.description}}</p>
    @if (cartItemTotal) {
      <div class="prod-total">
        <p class="price-data">Total: <span class="price total">{{cartItemTotal.total | currency}}</span></p>
        <p class="benefits-data">Benefit Covers: <span class="price total">{{cartItemTotal.benefitAmount | currency}}</span></p>
      </div>
    }
  </div>
</div>
